module.exports = __webpack_public_path__ + "img/sponsorV03.6a736e4f.png";